<template>
  <VueSidePanel
    v-model="isSidePanelOpen"
    transition-name="slide-left"
    width="42%"
    side="left"
    body-class="bbSidePanelBody bbSidePanelBody-Item"
    panel-color="transparent"
    :z-index="5000"
  >
    <template #default>
      <div class="mt-2 px-4">
        <SpellCard
          :spell="spell"
          :spell_type="spell_type"
          :character="character"
          @add-character-spell="$emit('add-character-spell', $event)"
          @update-character-spell="$emit('update-character-spell', $event)"
          @delete-character-spell="$emit('delete-character-spell', $event)"
          @close-spell-panel="$emit('close-spell-panel', $event)"
        />
      </div>
    </template>
  </VueSidePanel>
</template>

<script>
import SpellCard from './SpellCard.vue'
import { VueSidePanel } from 'vue3-side-panel'
//---------
// scripts
//---------
export default {
  name: 'SpellSidePanel',
  emits: [
    'add-character-spell',
    'update-character-spell',
    'delete-character-spell',
    'close-spell-panel',
  ],
  //------------
  // components
  //------------
  components: {
    VueSidePanel,
    SpellCard,
  },
  //-------
  // props
  //-------
  props: {
    spell: {
      type: Object,
      required: false,
      default: null,
    },
    spell_type: {
      type: String,
      required: false,
      default: '',
    },
    character: {
      type: Object,
      required: true,
      default: null,
    },
  },
  //------
  // data
  //------
  data() {
    return {
      isSidePanelOpen: true, // mandatory for VueSidePanel
    }
  },
}
</script>

<style scoped>
.vsp-overlay {
  background: #1e1e1e !important;
  opacity: 0.2 !important;
}
</style>
